import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TodayAppointments } from '../../models/patient-model';

@Component({
  selector: 'app-today-appointment-card',
  standalone: false,
  templateUrl: './today-appointment-card.component.html',
  styleUrl: './today-appointment-card.component.scss',
})
export class TodayAppointmentCardComponent {
  @Input() appointment: TodayAppointments = {
    id: '',
    patient_id: '',
    patient_first_name: '',
    patient_last_name: '',
    date: '',
    start_time: '',
    is_remote: false,
  };
  @Output() changePatientEvent: EventEmitter<TodayAppointments> =
    new EventEmitter<TodayAppointments>();

  changePatient() {
    this.changePatientEvent.emit(this.appointment);
  }
}
